export const WATER_LOG_HP_REWARD_PER_GLASS = 1;
export const DEFAULT_WATER_GLASS_ML = 250;

export const MIN_WATER_ML = 50;
export const MAX_WATER_ML = 5000;

export const DEFAULT_DAILY_WATER_GOAL_ML = 2000;
export const MIN_DAILY_WATER_GOAL_ML = 500;
export const MAX_DAILY_WATER_GOAL_ML = 6000;
export const DAILY_WATER_GOAL_ML_STEP = 250;

export const DAILY_WATER_GOAL_ML_VALUES: number[] = Array.from(
    { length: Math.round((MAX_DAILY_WATER_GOAL_ML - MIN_DAILY_WATER_GOAL_ML) / DAILY_WATER_GOAL_ML_STEP) + 1 },
    (_, i) => MIN_DAILY_WATER_GOAL_ML + i * DAILY_WATER_GOAL_ML_STEP,
);

export type WaterAmountValidation = { ok: true; value: number } | { ok: false; message: string };

export function validateWaterMl(n: number): WaterAmountValidation {
    const ml = Math.round(n);
    if (!Number.isFinite(ml)) {
        return { ok: false, message: 'Enter a valid amount' };
    }
    if (ml < MIN_WATER_ML || ml > MAX_WATER_ML) {
        return { ok: false, message: `Amount must be between ${MIN_WATER_ML} and ${MAX_WATER_ML} ml` };
    }
    return { ok: true, value: ml };
}

export function waterHpForMl(ml: number): number {
    return Math.max(1, Math.round((ml / DEFAULT_WATER_GLASS_ML) * WATER_LOG_HP_REWARD_PER_GLASS));
}

export function waterHpEarnedForTotal(totalMl: number): number {
    return Math.round((totalMl / DEFAULT_WATER_GLASS_ML) * WATER_LOG_HP_REWARD_PER_GLASS);
}

export function waterHpForEntry(entryMl: number, priorTotalMl: number, waterGoalMl: number | null): number {
    if (waterGoalMl == null) {
        return waterHpForMl(entryMl);
    }
    const newTotalMl = priorTotalMl + entryMl;
    const hpBefore = priorTotalMl >= waterGoalMl ? waterHpEarnedForTotal(priorTotalMl) : 0;
    const hpAfter = newTotalMl >= waterGoalMl ? waterHpEarnedForTotal(newTotalMl) : 0;
    return Math.max(0, hpAfter - hpBefore);
}

export type DailyWaterGoalValidation = { ok: true; value: number | null } | { ok: false; message: string };

export function validateDailyWaterGoalMl(n: number | null | undefined): DailyWaterGoalValidation {
    if (n == null || !Number.isFinite(n) || n <= 0) {
        return { ok: true, value: null };
    }
    const rounded = Math.round(n / DAILY_WATER_GOAL_ML_STEP) * DAILY_WATER_GOAL_ML_STEP;
    if (rounded < MIN_DAILY_WATER_GOAL_ML || rounded > MAX_DAILY_WATER_GOAL_ML) {
        return { ok: false, message: `Water goal must be between ${MIN_DAILY_WATER_GOAL_ML} and ${MAX_DAILY_WATER_GOAL_ML} ml` };
    }
    return { ok: true, value: rounded };
}

export function normalizeDailyWaterGoalMl(n: number | null | undefined): number | null {
    const checked = validateDailyWaterGoalMl(n);
    if (!checked.ok) throw new Error('INVALID_DAILY_WATER_GOAL_ML');
    return checked.value;
}
